module.exports = __webpack_public_path__ + "static/workflow_management-d4dba67791d0e9d7cf6b586d5d326118.jpg";